import React from 'react'
import EmailVerificationEnvelopeIllustration from './EmailVerificationEnvelopeIllustration'
import EmailVerificationButtonLabel from './EmailVerificationButtonLabel'
import EmailVerificationEmailRow from './EmailVerificationEmailRow'

// Combined screen for whenever affirmPrimary and/or affirmBackup is due (and
// there's a backup email) — one "yes, they are" affirms both addresses in a
// single action instead of separate lightweight asks.
const EmailVerificationAffirmBothOffer = (props) => {
  const {
    title, affirmLabel, primaryEmail, backupEmail, onAffirm, onRemindLater,
    onDifferentPrimaryEmail, onDifferentBackupEmail,
    onConfirmedAction, confirmedActionLabel,
    confirmLoading, confirmedMessage, errorMessage,
  } = props

  return (
    <div className='emailVerificationFlow-primaryOffer'>
      <EmailVerificationEnvelopeIllustration checkColor={confirmedMessage ? '#30C99C' : undefined} />
      {/* the question is answered once confirmed, so the success message
          takes its place rather than showing separately */}
      <div className='emailVerificationFlow-title'>{confirmedMessage || title}</div>
      <div className='emailVerificationFlow-emailBox'>
        <div className='emailVerificationFlow-emailBox-label'>Account email address</div>
        <EmailVerificationEmailRow
          email={primaryEmail}
          onEdit={confirmedMessage ? undefined : onDifferentPrimaryEmail}
          editAriaLabel='Update account email address'
        />
        <div className='emailVerificationFlow-emailBox-label emailVerificationFlow-emailBox-label--spaced'>
          Backup email address
        </div>
        <EmailVerificationEmailRow
          email={backupEmail}
          onEdit={confirmedMessage ? undefined : onDifferentBackupEmail}
          editAriaLabel='Update backup email address'
        />
      </div>
      {errorMessage && (
        <div className='emailVerificationFlow-error'>{errorMessage}</div>
      )}
      <button
        type='button'
        className={`btn btn--blue btn--large${confirmLoading ? ' btn--disabled' : ''}`}
        onClick={confirmedMessage ? onConfirmedAction : onAffirm}
        disabled={confirmLoading}
      >
        <EmailVerificationButtonLabel
          label={confirmedMessage ? confirmedActionLabel : affirmLabel}
          loading={confirmLoading}
        />
      </button>
      {!confirmedMessage && (
        <div className='emailVerificationFlow-primaryOffer-links'>
          <button
            type='button'
            className='emailVerificationFlow-linkBtn'
            onClick={onRemindLater}
          >
            Remind me later
          </button>
        </div>
      )}
    </div>
  )
}

EmailVerificationAffirmBothOffer.defaultProps = {
  title: 'Are these still your email addresses?',
  affirmLabel: 'Yes, they are',
}

export default EmailVerificationAffirmBothOffer
